// extracted by mini-css-extract-plugin
export default {"catalog":"zdRxl ZdH1P","list":"voKsM","item":"oTRra","double":"t1Y7d","moreWrapper":"aYIny","moreButton":"MMwSJ"};